import Vue from 'vue'
import EventBus from "@/plugins/eventBus";
import {Indicator, MessageBox, Toast, Swipe, SwipeItem, Lazyload} from 'mint-ui';

Vue.component(Swipe.name, Swipe);
Vue.component(SwipeItem.name, SwipeItem);
Vue.use(Lazyload, {
	preLoad: 1.3,
	error: require('@/assets/images/no_image.png'),
	attempt: 1
})

Vue.mixin({
	data() {
		return {
			menuType: '',  // 메뉴타입 (community : 커뮤니티 / serviceCenter : 고객센터)
		}
	},
	created() {
		if (this.storageGet('vuex') != null) {
			this.menuType = ([9999, 4, 36].includes(this.storageGet('vuex', 'boardActiveCode'))) ? 'serviceCenter' : 'community'
		}
	},
	// $el 생성후
	mounted() {
		window.tokenReceive = this.tokenReceive;
		window.pushLink = this.pushLink;
	},
	methods: {
		// 스토리지 데이터 가져오기
		storageGet(item, key) {
			let _data = JSON.parse(localStorage.getItem(item));
			if (key !== undefined) {
				return _data[key];
			} else {
				return _data;
			}
		},
		// 스토리지 데이터 저장하기
		storageSet(item, data) {
			localStorage.setItem(item, JSON.stringify(data))
		},
		// 스토리지 데이터 삭제하기
		storageRemove(item) {
			localStorage.removeItem(item);
		},
		// 로그인 여부 체크
		loginCheck() {
			if (!this.$store.state.authUserSId) {
				this.gotoLink('/login')
			}
		},
		// Ajax Get (인증사용)
		ajaxGetAuth(url, params, callBack) {
			let ajaxLoading = setTimeout(() => {
				Indicator.open({
					text: 'Loading...',
					spinnerType: 'fading-circle'
				});
			}, 500);

			// eslint-disable-next-line no-undef
			axios.get(url, {params: params, headers: {'strAuthUserSId': this.$store.state.authUserSId}})
				.then((response) => {
					Indicator.close();
					clearInterval(ajaxLoading);
					if (typeof callBack === "function") {
						callBack(response.data, params);
					}
				}, (error) => {
					clearInterval(ajaxLoading);
					Indicator.close();
					if (error) {
						Toast({
							message: error.response.data.message,
							position: 'middle',
							duration: 1000
						});
					}
				})
		},
		// Ajax Post (인증사용)
		ajaxPostAuth(url, formData, callBack) {
			let ajaxLoading = setTimeout(() => {
				Indicator.open({
					text: 'Loading...',
					spinnerType: 'fading-circle'
				});
			}, 500);

			// eslint-disable-next-line no-undef
			axios.post(url, formData, {
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
					'strAuthUserSId': this.$store.state.authUserSId
				}
			})
				.then((response) => {
					Indicator.close();
					clearInterval(ajaxLoading);
					if (typeof callBack === "function") {
						callBack(response.data, formData);
					}
				}, (error) => {
					clearInterval(ajaxLoading);
					Indicator.close();
					if (error) {
						Toast({
							message: error.response.data.message,
							position: 'middle',
							duration: 1000
						});
					}
				})
		},
		// Ajax File 업로드 (인증사용)
		ajaxUpload(url, formData, callBack) {
			let ajaxLoading = setTimeout(() => {
				Indicator.open({
					text: 'Loading...',
					spinnerType: 'fading-circle'
				});
			}, 500);

			// eslint-disable-next-line no-undef
			axios.post(url, formData, {
				headers: {
					'Content-Type': 'multipart/form-data',
					'strAuthUserSId': this.$store.state.authUserSId
				}
			})
				.then((response) => {
					Indicator.close();
					clearInterval(ajaxLoading);
					if (typeof callBack === "function") {
						callBack(response.data, formData);
					}
				}, (error) => {
					clearInterval(ajaxLoading);
					Indicator.close();
					if (error) {
						Toast({
							message: error.response.data.message,
							position: 'middle',
							duration: 1000
						});
					}

					if (this.errorAxios) {
						this.errorAxios();
					}
				})
		},
		// Ajax Get (인증사용 안함)
		ajaxGet(url, params, callBack) {
			let ajaxLoading = setTimeout(() => {
				Indicator.open({
					text: 'Loading...',
					spinnerType: 'fading-circle'
				});
			}, 500);

			// eslint-disable-next-line no-undef
			axios.get(url, {params: params})
				.then((response) => {
					Indicator.close();
					clearInterval(ajaxLoading);
					if (typeof callBack === "function") {
						callBack(response.data);
					}
				}, (error) => {
					clearInterval(ajaxLoading);
					Indicator.close();
					if (error) {
						Toast({
							message: error.response.data.message,
							position: 'middle',
							duration: 1000
						});
					}
				})
		},
		// Ajax Post (인증사용 안함)
		ajaxPost(url, formData, callBack) {
			let ajaxLoading = setTimeout(() => {
				Indicator.open({
					text: 'Loading...',
					spinnerType: 'fading-circle'
				});
			}, 500);

			// eslint-disable-next-line no-undef
			axios.post(url, formData, {headers: {'Content-Type': 'multipart/form-data'}})
				.then((response) => {
					Indicator.close();
					console.log('ajaxPost', callBack)
					clearInterval(ajaxLoading);
					if (typeof callBack === "function") {
						callBack(response.data, formData);
					}
				}, (error) => {
					clearInterval(ajaxLoading);
					Indicator.close();
					if (error) {
						Toast({
							message: error.response.data.message,
							position: 'middle',
							duration: 1000
						});
					}
				})
		},
		// Alert 창
		mintAlert(msg) {
			MessageBox({
				title: '',
				message: msg,
				confirmButtonText: '확인'
			});
		},


		// Confirm 창
		mintConfirm(msg, callBack = undefined) {
			MessageBox({
				title: '',
				message: msg,
				showCancelButton: true,
				cancelButtonText: '취소',
				confirmButtonText: '확인'
			}).then(action => {
				if (action === 'confirm') {
					if (callBack) {
						this[callBack]();
					} else {
						return true;
					}
				} else {
					return false;
				}
			}).catch(error => {
				if (error === 'cancel') {
					console.log('点击取消');
				}
			})
		},
		// toast 창
		toastMsg(msg, time, position) {
			Toast({
				message: msg,
				position: position ? position : 'bottom',
				duration: time
			});
		},
		// 라운터 에러 예외처리
		routerCatchError(err) {
			// Ignore the vuex err regarding  navigating to the page they are already on.
			if (err.name !== "NavigationDuplicated") {
				// But print any other errors to the console
				console.error(err);
			}
		},
		// input text 길이 제한
		textLenFunc(e, num) {
			let obj = e.target.value;
			if (obj.length > 6) {
				e.target.value = obj.substring(0, num);
			}
		},
		// slide 닫기
		slidePanelClose(result) {
			this.$emit("closePanel", result);
		},
		// 게시글 읽음 여부 체크
		boardReadCheck(seq) {
			if (this.$store.state.boardReadList.includes(seq)) {
				return 'disabled';
			} else {
				return ''
			}
		},
		// GNB 메뉴 리스트 - 전체 호출
		gnbAllDataFunc() {
			let param = {};
			this.ajaxGetAuth('/api/v1/gnb/all', param, this.gnbAllDataFuncResult);
		},
		// GNB 메뉴 리스트 - 전체 결과
		gnbAllDataFuncResult(response) {
			let result = response.result;
			if (result.code == 0) {
				this.$store.commit('setUserNum', response.oProfile.oUser.nUserNum);
				this.$store.commit('setUserId', response.oProfile.oUser.strUserId);
				this.$store.commit('setUserName', response.oProfile.oUser.strNickName);
				this.$store.commit('setUserProfile', response.oProfile.oUser.profileImg);
				this.$store.commit('setBoardList', response.oCategoryList);

				this.$store.commit('setProductInfo', response.oProduction);
				this.$store.commit('setNoticeAlarmCnt', response.oNotice.cnt);

				this.gotoLink('/main')
			} else {
				this.resultErrorMsg = result.resultNoti.message;
			}
		},
		// url 복사
		copyUrl(url) {
			var textarea = document.createElement('textarea');
			textarea.value = url;

			document.body.appendChild(textarea);
			textarea.select();
			textarea.setSelectionRange(0, 9999);  // 추가

			document.execCommand('copy');
			document.body.removeChild(textarea);

			this.toastMsg('URL이 복사되었습니다.', 1500);
		},
		// 이미지 에러시 대체 이미지 표시
		imgError(e) {
			e.target.src = require('@/assets/images/no_image.png')
		},
		// 사용자 정보 레이어팝업 닫기
		removeUserPopup() {
			// 일반 게시판
			if (document.querySelectorAll('.boardListStyle .info .name.on').length > 0) {
				document.querySelectorAll('.boardListStyle .info .name.on').forEach(el => el.classList.remove('on'))
			}

			// 썸네일 게시판
			if (document.querySelectorAll('.boardGalleryStyle .info .name.on').length > 0) {
				document.querySelectorAll('.boardGalleryStyle .info .name.on').forEach(el => el.classList.remove('on'))
			}

			// 게시글 상세 댓글
			if (document.querySelectorAll('.Detail .comment-area-list .option.on').length > 0) {
				document.querySelectorAll('.Detail .comment-area-list .option.on').forEach(el => el.classList.remove('on'))
			}

			// 게시글 상세 댓글
			if (document.querySelectorAll('.userPopupInfo .name.on').length > 0) {
				document.querySelectorAll('.userPopupInfo .name.on').forEach(el => el.classList.remove('on'))
			}
		},
		// 이용약관 내역
		useTermsFunc() {
			this.ajaxGetAuth('/api/v1/join/useTerms', '', this.useTermsFuncResult);
		},
		// 이용약관 결과
		useTermsFuncResult(response) {
			let result = response.result;

			if (result.code == 0) {
				this.useTermsText = result.useTerms;
			}
		},
		// 개인정보 취급 방침 내역 호출
		personalInfoCollectFunc() {
			this.ajaxGetAuth('/api/v1/join/personalInfoCollect', '', this.personalInfoCollectFuncResult);
		},
		// 개인정보 취급 방침 내역 결과
		personalInfoCollectFuncResult(response) {
			let result = response.result;

			if (result.code == 0) {
				this.personalText = result.useTerms;
			}
		},
		// 커뮤니티 운영정책 호출
		useCommunityFunc() {
			this.ajaxGetAuth('/api/v1/join/communityUseTerms', '', this.useCommunityFuncResult);
		},
		// 커뮤니티 운영정책 결과
		useCommunityFuncResult(response) {
			let result = response.result;

			if (result.code == 0) {
				this.communityText = result.useTerms;
			}
		},
		// 게시글 상세페이지 이동
		boardDetailMove(boardId, seq, oAuthorizeAccessRead) {
			// 게시글 읽기 권한 체크
			if (!oAuthorizeAccessRead.bAuthorizeAccess) {
				this.mintAlert(oAuthorizeAccessRead.strMessage);
				return false;
			}

			// 게시글 클릭시 읽음 여부 저장
			if (!this.$store.state.boardReadList.includes(seq)) {
				let boardReadList = this.$store.state.boardReadList;
				boardReadList.push(seq);
				this.$store.commit('setBoardReadList', boardReadList);
			}

			let props = {
				pBoardId: boardId,
				pBoardSeq: seq,
			};
			const prevBackKeyEvent = window.callbackBackKey;
			const panel = this.$showPanel({
				component: () => import('@/views/board/Detail.vue'),
				props: props,
				openOn: 'right',
				width: screen.width,
			});

			panel.promise.then(result => {
				console.log("Detail View Close")
				window.callbackBackKey = prevBackKeyEvent
				if (result === "reload") {
					this.boardReload();
				}

				if (result === "close") {
					this.slidePanelClose(result);
				}
			});

		},
		// swipe 이미지 높이 자동 계산
		imgLoad(e) {
			if (this.swiperHeight) return
			this.swiperHeight = e.target.clientHeight;
		},
		// 쪽지 상세보기
		noteViewSlideView(noteTab, idx) {
			let props = {
				pNoteTab: noteTab,
				pIdx: idx,
			};
			const prevBackKeyEvent = window.callbackBackKey
			const panel = this.$showPanel({
				component: () => import('@/views/slide/NoteView.vue'),
				props: props,
				openOn: 'right',
				width: screen.width,
			});
			panel.promise.then(result => {
				window.callbackBackKey = prevBackKeyEvent
				if (result === "reload") {
					this.getMessageList(1);
				}

				if (result === "sendReload") {
					this.sendReload('send');
				}
			});
		},
		// 주소검색
		postCodeSlideView() {
			const prevBackKeyEvent = window.callbackBackKey
			const panel = this.$showPanel({
				component: () => import('@/views/slide/Postcode.vue'),
				openOn: 'right',
				width: screen.width,
			});
			panel.promise.then(result => {
				window.callbackBackKey = prevBackKeyEvent;
				if (result.result === "close") {
					this.setPostCode(result);
				}

			});
		},
		// 선택한 element Class 이름 Toggle
		toggleClass(e, className) {
			let element = e.currentTarget;
			if (element.classList.contains(className) == false) {
				element.classList.add(className);
			} else {
				element.classList.remove(className);
			}
		},
		// 이름 클릭시 사용자 정보 노출
		userPopupToggleClass(e, className) {
			document.querySelectorAll('.userPopupInfo .name.on').forEach(el => el.classList.remove('on'))
			let element = e.currentTarget;
			if (element.classList.contains(className) == false) {
				element.classList.add(className);
			} else {
				element.classList.remove(className);
			}
		},
		// 선택한 element 부모 Class 이름 Toggle
		toggleParentClass(e, className) {
			this.removeUserPopup();
			let element = e.currentTarget.parentElement;
			if (element.classList.contains(className) == false) {
				element.classList.add(className);
			} else {
				element.classList.remove(className);
			}
		},
		// 게시글 카테고리 이동
		pageMove(code, accessMenu = true) {
			console.log("pageMove")
			if (accessMenu == false) {
				this.toastMsg('상품구매 후 이용이 가능합니다', 1500)
				return false
			}

			// eslint-disable-next-line no-unused-vars
			let index = '';
			let board = '';
			let menuType = ([9999, 4, 36].includes(code)) ? 'serviceCenter' : 'community';

			// eslint-disable-next-line no-unused-vars
			let bAllowAccessMenu = true;
			if (menuType == 'community') {
				board = this.$store.state.boardList.community;
			} else {
				board = this.$store.state.boardList.serviceCenter;
			}

			index = board.child.findIndex(function (item) {
				return item.nMenuNum === code
			});
			bAllowAccessMenu = board.child[index].bAllowAccessMenu;

			if (bAllowAccessMenu == false) {
				this.mintAlert('상품 구매 후<br/>이용 가능한 게시판입니다.');
				return false;
			}

			this.slidePanelClose('close');
			this.gotoBoard(code)
		},
		// 게시글 이동
		gotoBoard(code) {
			this.gotoHistoryUrl(code);
			this.$router.push('/list/' + code);
		},
		// 게시글 이동 히스토리(기존 카테고리 이전, 다음 기능)
		gotoHistoryUrl(code) {
			this.$store.commit('setBoardActiveCode', code);

			let history = this.$store.state.historyUrl;
			history.push(code);
			this.$store.commit('setHistoryUrl', history);
		},
		// Footer 메뉴 > 이전 게시글
		boardPrev() {
			console.log("boardNext")
			this.slidePanelClose({});
			let vm = this;
			let board = '';
			let selectIdx = '';

			// community 메뉴 또는 메인 화면일 경우
			if (this.menuType == 'community' || this.$route.name == 'Main') {
				board = this.$store.state.boardList.community;
				// 고객센터
			} else {
				board = this.$store.state.boardList.serviceCenter;
			}

			let boardChild = [];
			board.child.forEach(function (item) {
				if (item.bAllowAccessMenu === true) {
					boardChild.unshift(item)
				}
			})

			// 메인화면에서 뒤로가기
			if (vm.$store.state.boardActiveCode == '') {
				selectIdx = boardChild[0].nMenuNum;
				this.gotoBoard(selectIdx)
				// 리스트화면에서 뒤로가기
			} else {
				boardChild.forEach(function (item, key) {
					if (item.nMenuNum === vm.$store.state.boardActiveCode) {
						selectIdx = key + 1
					}
				})
				// 맨 처음 메뉴일 경우
				if (selectIdx == boardChild.length) {
					this.gotoBoard(boardChild[0].nMenuNum)
				} else {
					this.gotoBoard(boardChild[selectIdx].nMenuNum)
				}
			}
		},
		// Footer 메뉴 > 다음 게시글
		boardNext() {
			console.log("boardPrev")
			this.slidePanelClose();
			let vm = this;
			let board = '';
			let selectIdx = '';

			// community 메뉴 또는 메인 화면일 경우
			if (this.menuType == 'community' || this.$route.name == 'Main') {
				board = this.$store.state.boardList.community;
				// 고객센터
			} else {
				board = this.$store.state.boardList.serviceCenter;
			}

			let boardChild = [];
			board.child.forEach(function (item) {
				if (item.bAllowAccessMenu === true) {
					boardChild.push(item)
				}
			})

			// 메인화면에서 뒤로가기
			if (vm.$store.state.boardActiveCode == '') {
				selectIdx = boardChild[0].nMenuNum;
				this.gotoBoard(selectIdx)
				// 리스트화면에서 뒤로가기
			} else {
				boardChild.forEach(function (item, key) {
					if (item.nMenuNum === vm.$store.state.boardActiveCode) {
						selectIdx = key + 1
					}
				})

				// 맨 처음 메뉴일 경우
				if (selectIdx == boardChild.length) {
					this.gotoBoard(boardChild[0].nMenuNum)
				} else {
					this.gotoBoard(boardChild[selectIdx].nMenuNum)
				}
			}
		},
		// 앱에 토큰정보 요청
		tokenSendFunc() {
			let uAgent = navigator.userAgent.toLocaleLowerCase();
			// Android
			if (uAgent.indexOf("mobigo_android") != -1) {
				window.Android.callFcmToker();
				// IOS
			} else if (uAgent.indexOf("mobigo_ios") != -1) {
				// eslint-disable-next-line no-undef
				webkit.messageHandlers.callbackHandler.postMessage('callFcmToker');
			}
		},
		// 앱에서 토큰정보 받기
		tokenReceive(token, strAppVer) {
			if (!token) {
				return false;
			}

			let uAgent = navigator.userAgent.toLocaleLowerCase();
			let strOs = 'ios';
			if (uAgent.indexOf("mobigo_android") != -1) {
				strOs = 'and';
			}

			let formData = new FormData();
			formData.append('strRegistrationId', token);
			formData.append('strOs', strOs);
			formData.append('strAppVer', strAppVer);

			this.ajaxPostAuth('/api/v1/push/collect/registrationId', formData);
		},
		// 푸시클릭시 이동
		pushLink(data) {
			let obj = JSON.parse(data);
			if (obj.arrBannerLink.strLinkType == 'in') {
				// 게시글로 이동
				if (obj.arrBannerLink.strLinkMove == 'boardDetail') {
					let boardInfo = obj.arrBannerLink.detail.split('||');
					let boardId = boardInfo[0];
					let boardNum = boardInfo[1];

					this.boardDetailMove(boardId, boardNum, obj.arrBannerLink.oAuthorizeAccessRead)
					// 받은쪽지
				} else if (obj.arrBannerLink.strLinkMove == 'receiveDetail') {
					this.noteViewSlideView('receive', obj.arrBannerLink.detail)
					// 보낸쪽지
				} else if (obj.arrBannerLink.strLinkMove == 'sendDetail') {
					this.noteViewSlideView('send', obj.arrBannerLink.detail)
					// 앱내 브라우저
				} else {
					window.location.href = obj.arrBannerLink.detail;
				}
				//  out : 외부 브라우저
			} else {
				let uAgent = navigator.userAgent.toLocaleLowerCase();
				// Android
				if (uAgent.indexOf("mobigo_android") != -1) {
					window.Android.openBrowser(obj.arrBannerLink.detail);
					// IOS
				} else if (uAgent.indexOf("mobigo_ios") != -1) {
					let openBrowserArray = new Array();
					openBrowserArray[0] = 'openBrowser';
					openBrowserArray[1] = obj.arrBannerLink.detail;

					window.webkit.messageHandlers.callbackHandler.postMessage(openBrowserArray);
				}
			}
		},
		// 배너 링크
		bannerLink(data) {

			// In : app 내
			if (data.arrBannerLink.strLinkType == 'in') {
				// 게시글로 이동
				if (data.arrBannerLink.strLinkMove == 'boardDetail') {
					let boardInfo = data.arrBannerLink.detail.split('||');
					let boardId = boardInfo[0];
					let boardNum = boardInfo[1];
					this.boardDetailMove(boardId, boardNum, data.oAuthorizeAccessRead)
					// 앱내 브라우저
				} else {
					window.location.href = data.arrBannerLink.detail;
				}
				//  out : 외부 브라우저
			} else {
				let uAgent = navigator.userAgent.toLocaleLowerCase();
				// Android
				if (uAgent.indexOf("mobigo_android") != -1) {
					window.Android.openBrowser(data.arrBannerLink.detail);
					// IOS
				} else if (uAgent.indexOf("mobigo_ios") != -1) {
					let openBrowserArray = new Array();
					openBrowserArray[0] = 'openBrowser';
					openBrowserArray[1] = data.arrBannerLink.detail;

					window.webkit.messageHandlers.callbackHandler.postMessage(openBrowserArray);
				}
			}
		},
		// 테스트 서버 주소변경 시 앱 요청
		funServerChangServer(url) {
			let uAgent = navigator.userAgent.toLocaleLowerCase();
			// Android
			if (uAgent.indexOf("mobigo_android") != -1) {
				window.Android.changeServer(url);
				// IOS
			} else if (uAgent.indexOf("mobigo_ios") != -1) {
				let changeServerArray = new Array();
				changeServerArray[0] = 'changeServer';
				changeServerArray[1] = url;

				window.webkit.messageHandlers.callbackHandler.postMessage(changeServerArray);
			}
		},
		// 최상단 이동
		boardTop(slideYn = 'N') {
			// Slide 일 경우
			if (slideYn == 'Y') {
				document.querySelector('.contents-area-slidePanel').scrollTop = 0
				// Page 일 경우
			} else {
				document.querySelector('.contents-container').scrollTop = 0;
			}
		},
		// 게시글 검색 Slide
		boardSearchSlideView() {
			this.slidePanelClose();
			this.isMenuState = 'closed';
			const prevBackKeyEvent = window.callbackBackKey
			const panel = this.$showPanel({
				component: () => import('@/views/board/Search'),
				openOn: 'right',
				width: screen.width,
			});

			panel.promise.then(result => {
				window.callbackBackKey = prevBackKeyEvent;
				if (result.result === "close") {
					this.slidePanelClose(result);
				}
			});
		},
		// 글쓰기 권한 체크
		boardWriteAuthCheck(nBoardNum = '') {
			this.slidePanelClose();
			let menuNum = (nBoardNum) ? nBoardNum : this.storageGet('vuex', 'boardActiveCode');
			if (menuNum == '') {
				this.boardWriteSlideView(nBoardNum);
			} else {
				let param = {};
				this.ajaxGetAuth('/api/v1/category/list/' + menuNum + '/writeConfrm', param, this.boardWriteAuthCheckResult);
			}
		},
		// 글쓰기 권한 체크 결과
		boardWriteAuthCheckResult(response) {
			if (response.result.code == 0) {
				this.boardWriteSlideView('');
			} else {
				this.toastMsg(response.result.resultNoti.message, 1500);
			}
		},
		// 게시글 쓰기 Slide
		boardWriteSlideView(nBoardNum = '') {
			let props = {
				pBoardNum: (nBoardNum) ? nBoardNum : '',
			};

			const prevBackKeyEvent = window.callbackBackKey
			const panel = this.$showPanel({
				component: () => import('@/views/board/Write'),
				props: props,
				openOn: 'right',
				width: screen.width,
			});

			panel.promise.then(result => {
				window.callbackBackKey = prevBackKeyEvent;
				if (result === "close") {
					this.slidePanelClose(result);
				}

				if (result === "detail_reload") {
					this.boardDetailReload();
				}

				if (result === "write_reload") {
					this.boardListReload();
				}
			});
		},
		// 작성글 보기 Slide
		myBoardWriteSlideView(nUserNum) {
			let props = {
				nUserNum: nUserNum,
			};
			const prevBackKeyEvent = window.callbackBackKey
			const panel = this.$showPanel({
				component: () => import('@/views/board/MyBoardWrite'),
				props: props,
				openOn: 'right',
				width: screen.width,
			});

			panel.promise.then(result => {
				this.removeUserPopup();
				window.callbackBackKey = prevBackKeyEvent;
				if (result.result === "close") {
					this.slidePanelClose(result);
				}
			});
		},
		// 회원 차단 ( 게시글/댓글 차단 기능) 호출
		memberBlock(nUserNum) {
			let formData = new FormData();
			this.ajaxPostAuth('/api/v1/member/' + nUserNum + '/block', formData, this.memberBlockResult);
		},
		// 회원 차단 ( 게시글/댓글 차단 기능) 결과
		memberBlockResult() {
			this.removeUserPopup();

			EventBus.$emit('reload-board-list', '');
		},
		// 페이지 이동
		gotoLink(link) {
			this.$router.push(link).catch(this.routerCatchError);
		},
		// 마이페이지 Slide
		mypageSlideView() {
			this.slidePanelClose('close');
			const prevBackKeyEvent = window.callbackBackKey
			const panel = this.$showPanel({
				component: () => import('@/views/slide/Mypage'),
				openOn: 'right',
				width: screen.width,
			});
			panel.promise.then(result => {
				window.callbackBackKey = prevBackKeyEvent;
				if (result.result === "close") {
					this.slidePanelClose(result);
				}
			});
		},
		// 파일 다운로드
		fileDownload(fileLink) {
			let uAgent = navigator.userAgent.toLocaleLowerCase();
			// Android
			if (uAgent.indexOf("mobigo_android") != -1) {
				window.Android.openBrowser(fileLink);
				// IOS
			} else if (uAgent.indexOf("mobigo_ios") != -1) {
				let openBrowserArray = new Array();
				openBrowserArray[0] = 'openBrowser';
				openBrowserArray[1] = fileLink;

				window.webkit.messageHandlers.callbackHandler.postMessage(openBrowserArray);
			}
		}
	}
})
